import React from "react";
import { WifiOff } from "lucide-react";
import { useApp } from "@/lib/store";

export default function Shell({ children, className = "" }) {
  const app = useApp();
  const offline = app && app.online === false;
  return (
    <div className="min-h-dvh w-full flex justify-center bg-[#EDEAE3]">
      <div
        className={`ss-grain relative w-full max-w-md min-h-dvh bg-[#FDFBF7] text-[#1A1A1A] shadow-[0_10px_60px_rgba(0,0,0,0.10)] overflow-x-hidden ${className}`}
      >
        {offline && (
          <div
            data-testid="offline-banner"
            className="sticky top-0 z-30 flex items-center justify-center gap-2 bg-[#1A1A1A] text-[#F5F3ED] text-[12.5px] py-2 px-4"
          >
            <WifiOff size={14} strokeWidth={1.5} />
            Offline — your check-in still works and will sync later.
          </div>
        )}
        <div className="relative z-[1]">{children}</div>
      </div>
    </div>
  );
}
